'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = computors;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _computors = require('../utils/computors');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    xDomain: function xDomain(options, data, range) {
      return (0, _computors.computeTimeDomain)(options.axis.x, target.computors.data(data), target.accessors.x, range);
    },
    xScale: function xScale(options, data, offset, annotationOffset) {
      var tickOffset = target.computors.xTickOffset(options, data);
      var range = target.computors.xRange(options, offset, tickOffset, annotationOffset);
      return (0, _computors.computeTimeScale)(range, target.computors.xDomain(options, data, range));
    },
    xAxis: _computors.computeTimeAxis,
    linesData: function linesData(serie, options) {
      var _R$path = R.path(['axis', 'x', 'linear'], options),
          frequency = _R$path.frequency,
          step = _R$path.step;

      var interval = R.has(frequency, d3.time) ? R.prop(frequency, d3.time) : d3.time.year;
      var datapoints = serie.datapoints;
      var _split = R.reduce(function (acc, dp) {
        var onGoingLine = R.last(acc);
        if (R.isNil(dp.y)) {
          return R.isEmpty(onGoingLine) ? acc : R.append([], acc);
        }
        if (R.isEmpty(onGoingLine)) {
          return R.over(R.lensIndex(-1), R.append(dp))(acc);
        }
        var lastDp = R.last(onGoingLine);
        var intervalRange = interval.range(target.accessors.x(lastDp), target.accessors.x(dp), step);
        return R.length(intervalRange) > 1 ? R.append([dp], acc) : R.over(R.lensIndex(-1), R.append(dp))(acc);
      }, [[]], datapoints);
      var split = R.isEmpty(R.last(_split)) ? R.dropLast(1, _split) : _split;
      return R.map(function (datapoints) {
        return (0, _extends3.default)({}, serie, { datapoints: datapoints });
      }, split);
    }
  });
}